import { IState } from '../../../store';

export const selectUser = (state: IState) => state.offerData.user;
